import React from 'react';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import PropTypes from 'prop-types';
import './filters.css';
import { useTranslation } from 'react-i18next';

function defaultFormat(value) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    }).format(value);
}

export function PriceFilter({
    min = 0,
    max = 100,
    lowerValue = 0,
    upperValue = 100,
    formatter = (value) => defaultFormat(value),
    onChange = () => {},
    label = null,
    reset: Reset = null,
}) {
    const [minInput, setMin] = React.useState(lowerValue);
    const [maxInput, setMax] = React.useState(upperValue);
    const { t } = useTranslation();

    const onChangeRange = React.useCallback(([min, max]) => {
        onChange({ min, max });
    }, []);

    React.useEffect(() => {
        setMin(lowerValue);
        setMax(upperValue);
    }, [lowerValue, upperValue]);

    return (
        <div className="range-filter-container">
            {label && (
                <div className="range-filter-label-container">
                    <span className="range-filter-label">{label}</span>
                </div>
            )}
            <div className="range-container">
                <Range
                    allowCross={false}
                    value={[minInput, maxInput]}
                    min={min}
                    max={max}
                    onChange={onChangeRange}
                />
            </div>
            <div className="range-input-container">
                <div className={'input-price'}>
                    <span className={'input-price-label'}>{t('priceMinValue')}</span>
                    <span className={'input-price-value'}>{formatter(minInput)}</span>
                </div>
                <div className={'input-price input-price-right'}>
                    <span className={'input-price-label'}>{t('priceMaxValue')}</span>
                    <span className={'input-price-value'}>{formatter(maxInput)}</span>
                </div>
            </div>
            {<div className="number-filter-reset">{Reset && <Reset />}</div>}
        </div>
    );
}

PriceFilter.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    lowerValue: PropTypes.number,
    upperValue: PropTypes.number,
    formatter: PropTypes.func,
    onChange: PropTypes.func,
    label: PropTypes.string,
    reset: PropTypes.node,
};

export function NumberSelect({
    min = 0,
    max = 10,
    onChange = () => {},
    value = 0,
}) {
    const options = [];

    for (let i = min; i <= max; i++) {
        options.push(
            <option key={i} value={i}>
                {i}
            </option>,
        );
    }

    return (
        <select
            name="number-select"
            value={value}
            onChange={onChange}
            className="number-select"
        >
            {options}
        </select>
    );
}

NumberSelect.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
    value: PropTypes.number,
};

export function QuantityFilter({
    min = 0,
    max = 10,
    onChange = () => {},
    label = null,
    quantity = 0,
    reset: Reset = null,
}) {
    return (
        <div className="number-filter-container">
            {label && (
                <div className="number-filter-label-container">
                    <span className="number-filter-label">{label}</span>
                </div>
            )}
            <div className="number-select-container">
                <NumberSelect
                    min={min}
                    max={max}
                    onChange={onChange}
                    value={quantity}
                />
            </div>
            {<div className="number-filter-reset">{Reset && <Reset />}</div>}
        </div>
    );
}

QuantityFilter.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
    label: PropTypes.string,
    quantity: PropTypes.number,
    reset: PropTypes.node,
};

export function ResetFilter({
    onClick = () => {},
    children = null,
    label = null,
}) {
    return (
        <div className="reset-filter-container">
            {children ? (
                children
            ) : (
                <span onClick={onClick}>{label ? label : 'Reset filters'}</span>
            )}
        </div>
    );
}

ResetFilter.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    label: PropTypes.string,
};
